import type { MetaFunction } from 'react-router'
import { Chat } from '@/pages/Chat'

// Pagina di servizio (apre la chat + riconosce il cliente via token): fuori indice.
export const meta: MetaFunction = () => [
  { title: 'Assistenza — Spadhausen' },
  { name: 'robots', content: 'noindex, nofollow' },
]

export default function Route() {
  return <Chat />
}
